<template>
  <div id="app" :class="{'bg-white':!this.style.dark, 'bg-black':this.style.dark}" class="transition duration-500 transition-all">
    <div class="fixed z-40 top-0 right-0 p-4 items-center">
      <span class="inline-block animate-pulse" :class="{'green-text':!this.style.dark, 'text-blueviolet':this.style.dark}">Click here
        <font-awesome-icon :icon="['fa', 'arrow-right']" />
      </span>
      <div class="round ml-4 mr-8 inline-block">
        <input type="checkbox" id="checkbox" v-model="style.dark"/>
        <label class="flex items-center justify-center" :class="{'blue-text bg-white':!this.style.dark, 'text-blueviolet bg-black':this.style.dark}" for="checkbox"><font-awesome-icon :icon="['fa', 'eye']" size="2x" /></label>
      </div>
  
    </div>
    <Home :dark="style.dark"/>
    <Why :dark="style.dark"/>
    <Services :dark="style.dark"/>
    <Contact :dark="style.dark"/>
  </div>
</template>

<script>
import Home from './components/home'
import Why from './components/why'
import Services from './components/services'
import Contact from './components/contact'
import { styleWatchers, lifecycleHooks, data } from './shared';


export default {
  name: 'App',
  components: {
    Home,
    Why,
    Services,
    Contact
  },
  data() {
    return {
      style: {},
      bg:'bg-white',
      icon: ['fas', 'sun']
    }
  },
  mixins: [lifecycleHooks, styleWatchers],
  async created() {
    await this.loadStyle();
  },
  methods: {
    async loadStyle() {
      this.style = {};
      this.message = 'getting the heroes, please be patient';

      this.style = await data.getStyle();

      this.message = '';
    },
    selectStyle(style) {
      this.selectedStyle = style;
    },
    toggleStyle() {
      this.$emit('save', this.style);
      console.log(this.style);
    }
  }
}
</script>
<style>
  @font-face {
    font-family: "Droidiga";
    src: url("./assets/fonts/Droidiga.otf") format("truetype");
  }
  @font-face {
    font-family: "Long_Shot";
    src: url("./assets/fonts/Long_Shot.ttf") format("truetype");
  }
  @font-face {
    font-family: "Paul_Signature";
    src: url("./assets/fonts/Paul_Signature.ttf") format("truetype");
  }
  .long_shot {
    font-family: 'Long_Shot';
  }
  .paul_signature {
    font-family: 'Paul_Signature';
  }
  .droidiga {
    font-family: 'Droidiga';
  }
  .text-blueviolet {
    color: blueviolet;
  }
  .blue-bg {
    background-color:  #4795d1;
  }
  .blue-text {
    color:  #4795d1;
  }
  .green-bg {
    background-color:  #78c6bc;
  }
  .green-text {
    color:  #78c6bc;
  }
  .round {
    position: relative;
  }

  .round label {
    /* background-color: #fff; */
    border: 1px solid;
    border-radius: 50%;
    cursor: pointer;
    height: 45px;
    left: 0;
    position: absolute;
    top: 0;
    width: 45px;
  }

  .round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: "";
    height: 6px;
    left: 7px;
    opacity: 0;
    position: absolute;
    top: 8px;
    transform: rotate(-45deg);
    width: 12px;
  }

  .round input[type="checkbox"] {
    visibility: hidden;
  }
</style>

